module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "ecxForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ecxForm,
      "rules": _vm.actrules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "prop": "actName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "placeholder": "请输入活动名称",
      "maxlength": "40",
      "disabled": _vm.isCheckStatus
    },
    model: {
      value: (_vm.ecxForm.actName),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "actName", $$v)
      },
      expression: "ecxForm.actName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动开始时间",
      "prop": "startTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择开始日期",
      "disabled": _vm.isCheckStatus
    },
    on: {
      "change": _vm.getStartTime
    },
    model: {
      value: (_vm.ecxForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "startTime", $$v)
      },
      expression: "ecxForm.startTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动结束时间",
      "prop": "endTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择结束日期",
      "default-time": "23:59:59",
      "disabled": _vm.isCheckStatus
    },
    on: {
      "change": _vm.getEndTime
    },
    model: {
      value: (_vm.ecxForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "endTime", $$v)
      },
      expression: "ecxForm.endTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动说明",
      "prop": "remark"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ecxForm.remark),
      expression: "ecxForm.remark"
    }],
    staticStyle: {
      "width": "35%",
      "height": "100px"
    },
    attrs: {
      "placeholder": "活动说明",
      "maxlength": "500",
      "disabled": _vm.isCheckStatus
    },
    domProps: {
      "value": (_vm.ecxForm.remark)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ecxForm, "remark", $event.target.value)
      }, function($event) {
        _vm.descInput()
      }]
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.remnant) + "/500")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "24.5%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "next_step",
      "disabled": _vm.isorgsubmit
    },
    on: {
      "click": function($event) {
        _vm.submitForm('ecxForm')
      }
    }
  }, [_vm._v("下一步\n                ")])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "88%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#adadad",
      "width": "150px",
      "height": "40px",
      "text-align": "center",
      "vertical-align": "middle",
      "float": "left"
    }
  }, [_vm._v("\n            活动基础信息\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#adadad",
      "margin-left": "2px",
      "width": "35%",
      "height": "40px",
      "text-align": "center",
      "color": "#adadad",
      "float": "left"
    }
  }, [_vm._v("\n            活动基础信息\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a9172d64!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/activity/ActBase.vue
// module id = 1091
// module chunks = 2